<template>
  <div>user-item</div>
</template>

<script>
export default {
  name: "app-user-item"
};
</script>

<style lang="scss" scoped>
</style>
